import Vue from "vue";
import { sync } from "vuex-router-sync";
import Vuelidate from "vuelidate";
import BootstrapVue from "bootstrap-vue";
import VueLoading from "vue-loading-overlay";
import VuePromiseBtn from "vue-promise-btn";
import Snotify, { SnotifyPosition } from "vue-snotify";
import App from "./App.vue";
import router from "./router/index";
import store from "./state/store";
import "@components/_globals";
// Import stylesheet
import "vue-loading-overlay/dist/vue-loading.css";
import "vue-promise-btn/dist/vue-promise-btn.css";

const options = {
  toast: {
    position: SnotifyPosition.rightBottom,
    timeout: 5000,
    titleMaxLength: 25
  }
};

Vue.use(BootstrapVue);
Vue.use(Vuelidate);
Vue.use(VueLoading);
Vue.component("loading", VueLoading);
Vue.use(VuePromiseBtn);
Vue.use(Snotify, options);

const unsync = sync(store, router);

// Don't warn about using the dev version of Vue in development
Vue.config.productionTip = process.env.NODE_ENV === "production";

new Vue({
  router,
  store,
  destroyed() {
    unsync();
  },
  render: h => h(App)
}).$mount("#app");
